import React, { useCallback } from 'react';
import c from 'classnames';
import ArrowRight from '@wix/da-ds/pkg/Icons/ArrowRight';
import { CommonArrowButtonProps } from '@wix/da-ds/pkg/Slider/types';
import { ButtonProps } from './types';
import EditorIconButton from '../_partials/EditorIconButton';

import s from './buttons.scss';

interface Props extends CommonArrowButtonProps, ButtonProps {}

const SliderNext: React.FC<Props> = ({ onClick, className, editor }) => {
  const handleClick = useCallback(
    e => {
      onClick(e);
      editor.chain().focus().run();
    },
    [editor, onClick]
  );

  return (
    <EditorIconButton
      featureId="action:right"
      icon={ArrowRight}
      className={c(s['slider-button'], s['right'], className)}
      onClick={handleClick}
      /**
       * We can hide these from screen readers because they have
       * access to all of the slider content without these buttons
       */
      aria-hidden={'true'}
      // Just to satisfy typings
      aria-label="hidden"
    />
  );
};

SliderNext.displayName = 'SliderNextButton';

export default SliderNext;
